import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {DetalhesAtendimento} from "../../models/detalhes-atendimento";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute, Router} from "@angular/router";
import {AtendimentoService} from "../../services/atendimento.service";
import Swal from "sweetalert2";
import {AngularEditorConfig} from "@kolkov/angular-editor";

@Component({
    selector: 'app-detalhes',
    templateUrl: './detalhes.component.html',
    styleUrl: './detalhes.component.css',
    standalone: false
})
export class DetalhesComponent {
  @Input() isModal = false;
  @Output() atualizarLista = new EventEmitter();
  showModal = false;
  atendimento = new DetalhesAtendimento();
  formAlterarDados: FormGroup;
  id = 0;
  loading = true;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '200px',
    placeholder: 'Digite a declaração inicial aqui...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };

  constructor(private toastr: ToastrService,
              private route: ActivatedRoute,
              private atendimentoService: AtendimentoService,
              private formBuilder: FormBuilder,
              private router: Router){
    this.formConstruir();
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.id = params['id'];
        this.buscarPorId(this.id);
      }
      this.loading = false;
    });
  }

  abrirModal(id: number){
    this.id = id;
    this.showModal = true;
    this.loading = true;
    this.buscarPorId(id);
  }

  fecharModal(){
    this.showModal = false;
  }

  salvarAlteracoes(){
    Swal.fire({
      title: 'Deseja realmente alterar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.preencherModelo();
        this.atendimentoService.alterar(this.atendimento).subscribe(result => {
          this.loading = false;
          if(result.sucesso){
            this.toastr.success("Atendimento alterado com sucesso");
            if (this.isModal) {
              this.fecharModal();
              this.atualizarLista.emit();
            } else {
              this.buscarPorId(this.id);
            }
          } else {
            this.toastr.error("Erro ao alterar o atendimento - " + result.errors[0].mensagem);
          }
        }, error =>{
          this.loading = false;
          this.toastr.error("Erro ao alterar o atendimento - " + error);
        });
      }
    });
  }

  voltar(){
    if (this.isModal) {
      this.fecharModal();
    } else {
      this.router.navigate(['/cadastro/atendimento']);
    }
  }

  private preencherModelo(){
    this.atendimento.descricaoInicial = this.formAlterarDados.controls['descricaoInicial'].value;
    this.atendimento.descricao = this.formAlterarDados.controls['descricao'].value;
  }

  private formConstruir(){
    this.formAlterarDados = this.formBuilder.group({
      descricaoInicial: [this.atendimento.descricaoInicial, [Validators.required]],
      descricao: [this.atendimento.descricao, [Validators.required]]
    });
  }

  private buscarPorId(id: number) {
    this.atendimentoService.selecionarPorId(id).subscribe(response => {
      if(response.sucesso)
      {
        this.atendimento = response.dados;
        this.preencherFormulario();
      }
      this.loading = false;
    });
  }

  private preencherFormulario(){
    this.formAlterarDados.patchValue({
      descricaoInicial: this.atendimento.descricaoInicial,
      descricao: this.atendimento.descricaoResumida,
      telefoneSolicitante: this.atendimento.telefoneSolicitante,
    });
  }
}
